
import type { Channels } from '@eureka/login-sdk';
import { loginSDK, SDK_ENV } from '@eureka/login-sdk';
import { isUserLogin } from '@eureka/utils/account';
import { REGION } from '@eureka/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz'
import type { I18n } from 'vue-i18n';

export async function useLoginSdk(i18n: I18n, channels:Channels = {}) {
    const sdkEnv = [DeployEnv.US, DeployEnv.EU].includes(REGION) ? SDK_ENV.US : SDK_ENV.CN;
    loginSDK.setI18n(i18n).setEnv(sdkEnv).setChannels(channels)
    const is_login = await isUserLogin()
    if (!is_login) {
        loginSDK.open({
            withoutClose: true,
        }).then(async({ passport }) => {
            // ⚠️ 不设置，请求发不出去
            // setPrepareTokenDeferred(passport)
            window.location.reload();
        })
    }
}
